import React, { useContext } from "react";
import { adminFieldsArray } from "./fields";
import { PartnerContext } from "../context";
import { FieldsReducer } from "./../../../../CommonComponents/Reducer/Index";
import Card from "src/CommonComponents/Card";
export default function AdminTab() {
  const { _partnerData, onChange, operation, dropDowns } =
    useContext(PartnerContext);

  const mergedFieldData = (field) => {
    let newFieldObject = { ...field, dataSource: _partnerData, onChange };

    switch (operation) {
      case "Display":
        newFieldObject.disabled = true;
        break;
      case "Change":
        if (newFieldObject.key) {
          newFieldObject.disabled = true;
        }
        if (newFieldObject.displayOnly) {
          newFieldObject.disabled = true;
        }
        break;
      case "Create":
        if (newFieldObject.displayOnly) {
          newFieldObject.disabled = true;
        }
        break;
      default:
    }

    return newFieldObject;
  };

  const fieldsState = {
    dataSource: _partnerData,
    dropDowns,
  };

  const fieldsToRender = adminFieldsArray(fieldsState);
  return (
    <div className="row">
      <Card
        cardHeaderProps={{
          headerLabel: "Admin Data",
        }}
        cardBody={fieldsToRender?.map((field, index) => (
          <FieldsReducer field={mergedFieldData(field)} key={index} />
        ))}
        style={{ width: "25rem" }}
      />
    </div>
  );
}
